import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryQualityInspectionScanner extends BaseModelAPI {
	static entity = 'DeliveryQualityInspectionScanner';
	static entityName = 'deliveryqualityinspection';

	constructor(){

	/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.deliveryInstructionId = '';
		this.deliveryQualityInspectionId  = '';
		this.deliveryQualityInspectionDetailId  = '';
		this.deliveryQualityInspectionCardId  = '';
		this.partId  = '';
		this.qcStatusId  = '';
		this.deliveryInstructionNumber  = '';
		this.partNumber  = '';
		this.deliveryCardNumber  = '';
		this.remark  = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async doRequest(this_, method, data) {
        return this_.$http.post(`${this.entityName}/${method}`, data)
        .then(response => {
			return response.data;
        })
        .catch(function(error){
            // this_.$store.dispatch('addErrorMessageGlobal', error);
            throw error;
        });
    }

}